module.exports = __webpack_public_path__ + "img/ctj.0b743243.png";